import { BASE_DATETIME } from '@/utvStore/components/recommend/lp/commons'

import moment from 'moment'
const now = new moment()
const diffFromBase = now.diff(BASE_DATETIME, 'years')

const baseInfo = {
  id: 4,
  name: '法演',
  kana: 'ほうえん',
  roman: 'Houen',
  mainMethod: 'MITSURI',
  mainMethodKana: 'みつり',
}

const additionalInfo = {
  description: `どんな過ちも太陽のような笑顔ですべて受け入れ肯定し、その上で今なすべきことから逃げださず、幸せをつかめるよう背中を押す鑑定。痛いところをグッと押されるけれど、受け入れれば視界が開け、すっきり楽になる"心の足つぼマッサージ"のような占いは、病みつきになる芸能人が後を絶たない。`,
  methods: 'MITSURI',
  yearsOfAppraisal: `プロ歴${diffFromBase + 5}年`,
  appraisalNum: '推定2,000人',
  managementOffice: {
    name: 'Luck Out',
    url: '',
  },
}

const forProfilePage = {
  realNameBornPlaceAge: '非公表',
  basicFortune: `/recommend/${baseInfo.id}/basic/input`,
  profileImage: '/static/img/recommend/lp/houen/profileImage1.png',
  directAppraisal: {
    message: '占い師本人による直接鑑定は、現在WEBサービスでの特典（抽選制）でのみの受付となっています。詳細は各サービスの情報をご覧ください'
  },
  digitalFortune: {
    name: '占いTV',
    url: '',
  },
  salonTypeCommunity: {
    name: 'BaseCamp（月額制／毎月抽選での有料鑑定あり）',
    url: '',
  }
}

const tellerList = {
  description: '痛い所にズバッと切り込む"心の足つぼマッサージ"鑑定が評判の修験者占い師',
  thumbnail: '/static/img/recommend/lp/houen/counselor_160x160.jpg',
}

export default {
  ...baseInfo,
  ...additionalInfo,
  profilePage: forProfilePage,
  tellerList,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/houen/info/profile.js